import { render, staticRenderFns } from "./SpecialistProgressBooking.vue?vue&type=template&id=70d13166"
import script from "./SpecialistProgressBooking.vue?vue&type=script&lang=js"
export * from "./SpecialistProgressBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports